import React, { useContext, useEffect, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  Checkbox,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Srcs
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import {
  CREATE_CHART_OF_ACCOUNT,
  GET_ACCOUNT_TYPE,
} from "../../Schema/ChartOfAccount";
import { SelectAccountName } from "../Include/DynamicSelect";

export default function CreateChartOfAccount({
  open,
  handleClose,
  setRefetch,
}) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const [accountType, setAccountType] = useState("");
  const [parentsAccountVal, setParentsAccountVal] = useState({
    id: "",
    title: "",
  });
  const [selectAccountTypeVal, setSelectAccountTypeVal] = useState({
    id: "",
    title: "",
  });
  // ========================== checked box =================================
  const [checked, setChecked] = useState(false);
  // console.log("checked", checked);
  const hanldleChange = (event) => {
    setChecked(event.target.checked);
  };

  // ========================== get account type =================================
  const [accountTypeData, setAccountTypeData] = useState([]);
  const { refetch: refetchAccountType } = useQuery(GET_ACCOUNT_TYPE, {
    onCompleted: ({ getAccountType }) => {
      setAccountTypeData(getAccountType);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const [createChartOfAccount] = useMutation(CREATE_CHART_OF_ACCOUNT, {
    onCompleted: ({ createChartOfAccount }) => {
      setLoading(false);
     
      if (createChartOfAccount?.status === true) {
        setAlert(true, "success", createChartOfAccount?.message);
        handleClose();
        resetForm();
        setRefetch();
        setParentsAccountVal({ id: "", title: "" });
        setFieldValue("account_type", "");
      } else {
        setAlert(true, "error", createChartOfAccount?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  // console.log("accountType::", accountType)
  const CheckValidation = Yup.object().shape({
    account_type: Yup.string().required("require!"),
    account_name: Yup.string().required("require!"),
    code_account: Yup.string(),
    parents_account: Yup.string(),
    account_description: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      account_type: "Cash on hand",
      account_name: "",
      code_account: "",
      parents_account: "",
      account_description: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values::", values);
      setLoading(true);
      createChartOfAccount({
        variables: {
          input: {
            ...values,
            parents_account:
              values?.parents_account === "" ? null : values?.parents_account,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (parentsAccountVal?.id !== "" || parentsAccountVal?.id !== undefined) {
      setFieldValue("parents_account", parentsAccountVal?.id);
    }
  }, [parentsAccountVal?.id]);

  useEffect(() => {
    if (checked === false) {
      setFieldValue("parents_account", "");
      setParentsAccountVal({
        id: "",
        title: "",
      });
    }
  }, [checked]);

  useEffect(() => {
    if (values?.account_type) {
      setAccountType(values?.account_type);
    }
  }, [values?.account_type]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Create chart of account
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Typography className="field-title">Account type</Typography>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    value={values?.account_type}
                    onChange={(e) =>
                      setFieldValue("account_type", e.target.value)
                    }
                    {...getFieldProps("account_type")}
                    error={Boolean(touched.account_type && errors.account_type)}
                    helperText={touched.account_type && errors.account_type}
                  >
                    {accountTypeData?.map((e) => (
                      <MenuItem key={e} value={e}>
                        {e}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <Typography className="field-title">Code</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="code account"
                  {...getFieldProps("code_account")}
                />
              </Grid>

              <Grid item xs={12} md={8}>
                <Typography className="field-title">Account name</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="account name"
                  {...getFieldProps("account_name")}
                  error={Boolean(touched.account_name && errors.account_name)}
                  helperText={touched.account_name && errors.account_name}
                />
              </Grid>

              <Grid item xs={0.5} md={2} sx={{ marginTop: "15px" }}>
                <Checkbox
                  checked={checked}
                  onChange={hanldleChange}
                  iinputProps={{ "aria-label": "controlled" }}
                />
              </Grid>

              <Grid item xs={11.5} md={10}>
                <Typography className="field-title">
                  Select sub account
                </Typography>
                <SelectAccountName
                  selectedVal={parentsAccountVal}
                  setSelectVal={setParentsAccountVal}
                  accountType={values?.account_type}
                  disabled={
                    checked === false || values?.account_type === ""
                      ? true
                      : false
                  }
                />
                {(checked && values?.parents_account === "") ||
                (checked && values?.parents_account === undefined) ? (
                  <FormHelperText error id="outlined-adornment-password">
                    require!
                  </FormHelperText>
                ) : null}
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className="field-title">Description</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  multiline
                  rows={2}
                  placeholder="description"
                  {...getFieldProps("account_description")}
                  error={Boolean(
                    touched.account_description && errors.account_description
                  )}
                  helperText={
                    touched.account_description && errors.account_description
                  }
                />
              </Grid>
              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
